module.exports = __webpack_public_path__ + "img/produktbroschuren.a9bd68e3.png";